import Mock from 'mockjs';
import mockApi from './mockData/home'

// 1拦截的路径 2方法 3制造出的假数据
Mock.mock(/api\/home\/getMenuEn/, "get",mockApi.getMenuEn)
Mock.mock(/api\/home\/getMenu/, "get",mockApi.getMenu)
// Mock.mock(/api\/home\/getBanner/, "get",mockApi.getBanner)
// 基本陈列
Mock.mock(/api\/home\/getExhibitionA1Detail/, "post",mockApi.getExhibitionA1Detail)
Mock.mock(/api\/home\/getExhibitionA1/, "post",mockApi.getExhibitionA1)
// 特别展览
Mock.mock(/api\/home\/getExhibitionA2Detail/, "post",mockApi.getExhibitionA2Detail)
Mock.mock(/api\/home\/getExhibitionA2/, "post",mockApi.getExhibitionA2)
// 冠军故事
Mock.mock(/api\/home\/getExhibitionA4Detail/, "post",mockApi.getExhibitionA4Detail)
Mock.mock(/api\/home\/getExhibitionA4/, "post",mockApi.getExhibitionA4)
// 藏品展示
Mock.mock(/api\/home\/getCollectionA1Detail/, "post",mockApi.getCollectionA1Detail)
Mock.mock(/api\/home\/getCollectionA1/, "post",mockApi.getCollectionA1)
// 影音资料
Mock.mock(/api\/home\/getCollectionA2/, "post",mockApi.getCollectionA2)
// 活动信息
Mock.mock(/api\/home\/getActivityA1Detail/, "post",mockApi.getActivityA1Detail)
Mock.mock(/api\/home\/getActivityA1/, "post",mockApi.getActivityA1)
// 教育新闻
Mock.mock(/api\/home\/getExploreA1Detail/, "post",mockApi.getExploreA1Detail)
Mock.mock(/api\/home\/getExploreA1/, "post",mockApi.getExploreA1)
// 学术资讯
Mock.mock(/api\/home\/getExploreA2Detail/, "post",mockApi.getExploreA2Detail)
Mock.mock(/api\/home\/getExploreA2/, "post",mockApi.getExploreA2)
// 举重历史
Mock.mock(/api\/home\/getExploreA3Detail/, "post",mockApi.getExploreA3Detail)
Mock.mock(/api\/home\/getExploreA3/, "post",mockApi.getExploreA3)
// 通知公告
Mock.mock(/api\/home\/getNewsA1Detail/, "post",mockApi.getNewsA1Detail)
Mock.mock(/api\/home\/getNewsA1/, "post",mockApi.getNewsA1)
// 资讯动态
Mock.mock(/api\/home\/getNewsA2Detail/, "post",mockApi.getNewsA2Detail)
Mock.mock(/api\/home\/getNewsA2/, "post",mockApi.getNewsA2)

// 党建动态
Mock.mock(/api\/home\/getMuseumAffairsA3Detail/, "post",mockApi.getMuseumAffairsA3Detail)
Mock.mock(/api\/home\/getMuseumAffairsA3/, "post",mockApi.getMuseumAffairsA3)



// WEBPACK FOOTER //
// ./src/api/mock.js